/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle-check': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.284 3.119a.4.4 0 01-.003.566l-5.67 5.6a.4.4 0 01-.563-.002l-2.8-2.8a.4.4 0 11.565-.566l2.52 2.519 5.386-5.32a.4.4 0 01.566.003z" _fill="#3BB638"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M7 1.4a5.6 5.6 0 105.588 5.974.4.4 0 01.798.052 6.4 6.4 0 11-2.87-5.775.4.4 0 11-.44.668A5.572 5.572 0 007 1.4z" _fill="#3BB638"/>'
  }
})
